module.exports = __webpack_public_path__ + "assets/img/btn-more-3020638a.png";